import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { delay, reoccur, generateRandomNumber } from "../../../../utils";

import toast from "react-hot-toast";
import CustomButton from "../../../../common/CustomButton";
import CustomInput from "../../../../common/CustomInput";
import { SendVerificationCode } from "../../../../redux/v2/user/actions";

const RESEND_TIME = 60;

function CodeVerify(props) {
    const { email, SlideTo, userData } = props
    const [code, setCode] = useState("");
    const [sentCode, setSentCode] = useState("");
    const [timer, setTimer] = useState(null);
    const [time, setTime] = useState(RESEND_TIME);
    const [status, setStatus] = useState(0); // 0 dormant, 1 checking

    useEffect(async () => {
        await GenerateNumber();
        StartTimer();
    }, []);

    useEffect(() => {
        if (sentCode) {
            SendCode();
        }
    }, [sentCode])

    useEffect(() => {
        if (time < 1) {
            clearInterval(timer);
        }
    }, [time]);

    const SendCode = async () => {
        const res = await props.SendVerificationCode(email, userData?.first_name, sentCode);

        if (res) {

        } else {
            toast.error("Unable to send verification code.");
        }
    }

    const GenerateNumber = () => {
        let number = generateRandomNumber(999999);
        number = (number + "").padStart(6, "0");
        setSentCode(number);

        return;
    }

    const StartTimer = () => {
        setTimer(reoccur(() => {
            setTime(t => t - 1);
        }));
    }

    const VerifyCode = () => {
        if (code == sentCode || (process.env.REACT_APP_ENVIRONMENT === "DEV" && code == "7890")) {
            toast.success("Code Match!");
            delay(() => {
                SlideTo(3);
            }, 1000);
        } else {
            toast.error("Code didn't Match!");
        }
    }

    const Resend = (e) => {
        e.preventDefault();
        if (time < 1) {
            GenerateNumber();
            setTime(t => t + RESEND_TIME);
            StartTimer();

        }
    }

    return (
        <>
            <div id="cuv-email-verify">
                <div>
                    <h4>Verify your email address.</h4>
                    <p>A six-digit code was email to <a>{email}</a>. Enter it below. </p>
                </div>

                <div className="input-area">
                    <CustomInput
                        type="number"
                        value={code}
                        onChange={(e) => {
                            const val = e.target.value + "";
                            if (val.length <= 6) {
                                setCode(val);
                            }
                        }}
                    />
                    <h6>Didn't receive a code? Check your spam or promotions folder. <a onClick={Resend} className={time > 0 ? "disabled" : ""}>Resend {time > 0 ? ("(" + time + ")") : ""}</a></h6>
                </div>

                <div>
                    <CustomButton
                        disabled={!code}
                        onClick={() => {
                            VerifyCode();
                        }}
                    >
                        Verify
                    </CustomButton>
                </div>
            </div>
        </>
    );
}

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, {
    SendVerificationCode,
})(CodeVerify);